<template>

  <b-modal
    ref="modal"
    id="agLicenseModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="loginButton_clicked">
    <template slot="modal-header">
      <h4 class="agModal-title">License Information</h4>
    </template>
     <div class="agInputGroup">
      <label class="agLicenseModal-label">Customer Number:</label>{{customerNum}}
    </div>
    <div class="agInputGroup">
      <label class="agLicenseModal-label">License Key:</label>{{license}}
    </div>
     <div class="agInputGroup">
      <label class="agLicenseModal-label">Expiration:</label>{{expiration}}
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonRight" variant="primary" @click="cancel">OK</b-button>
    </template>
  </b-modal>

</template>





<script>

  // components


  // modules
  import Server from "src/server";
  import Moment from "moment";


  export default
  {
    name: "ag-license-modal",
    data()
    {
        return {
            
      };
    },
    computed:
    {
        customerNum() {
            return this.$store.state.customerNum;
        },

        license() {
            return this.$store.state.license;
        },

        expiration() {
            return this.$store.state.expiration;
        },
    },
    methods:
    {
        // UI Events

        // other methods

        show() {
          setTimeout(() => {
            this.reset();
            this.$refs.modal.show();
          }, 250);        
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          
        },
    }
  };

</script>






<style scoped lang="css">

.agLicenseModal-label {
    font-weight: bold;
    width: 150px;
}


</style>



// WEBPACK FOOTER //
// src/components/user/LicenseModal.vue